var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("Buy & Sell Stocks")]),_vm._v(" "),_c('h5',[_vm._v("You can load and save the data")]),_vm._v(" "),_c('h5',[_vm._v("Funds: "+_vm._s(_vm._f("currency")(_vm.funds)))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bdfbd3c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 29
// module chunks = 0